module.exports = __webpack_public_path__ + "img/banner4.b4af2ace.png";